import * as React from "react";
import { forwardRef } from "react";
const SvgJogMinus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 21, height: 21, viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "JogMinus" }, /* @__PURE__ */ React.createElement("path", { id: "Minus", d: "M0 13V8H21V13H0Z", fill: "white" })));
const ForwardRef = forwardRef(SvgJogMinus);
export default ForwardRef;
